import Lottie from "react-lottie";

const LoadingPage = (props) => (
  <div className="dclloadingpage">
    <Lottie
      isClickToPauseDisabled={true}
      width="150px"
      options={{
        loop: true,
        autoplay: true,
        animationData: {
          v: "5.9.0",
          fr: 29.9700012207031,
          ip: 0,
          op: 93.0000037879676,
          w: 596,
          h: 842,
          nm: "dolphincare logo",
          ddd: 0,
          assets: [],
          layers: [
            {
              ddd: 0,
              ind: 1,
              ty: 4,
              nm: "Layer 1 Outlines",
              sr: 1,
              ks: {
                o: { a: 0, k: 100, ix: 11 },
                r: {
                  a: 1,
                  k: [
                    {
                      i: { x: [0], y: [1] },
                      o: { x: [0.167], y: [0] },
                      t: 0,
                      s: [0],
                    },
                    {
                      i: { x: [0.374], y: [1] },
                      o: { x: [0.634], y: [0] },
                      t: 14,
                      s: [0],
                    },
                    {
                      i: { x: [0.833], y: [1] },
                      o: { x: [1], y: [0] },
                      t: 76,
                      s: [1440],
                    },
                    { t: 90.0000036657751, s: [1440] },
                  ],
                  ix: 10,
                },
                p: { a: 0, k: [288.367, 429.091, 0], ix: 2, l: 2 },
                a: { a: 0, k: [93.345, 120.962, 0], ix: 1, l: 2 },
                s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
              },
              ao: 0,
              shapes: [
                {
                  ty: "gr",
                  it: [
                    {
                      ind: 0,
                      ty: "sh",
                      ix: 1,
                      ks: {
                        a: 0,
                        k: {
                          i: [
                            [-1.22, 0],
                            [0, 0],
                            [41.02, 0],
                            [11.63, 36],
                            [0, 0],
                            [-0.51, 0.86],
                            [0, 0],
                            [0, 0],
                            [-1.15, 0],
                            [0, 0],
                            [-0.43, 1.07],
                            [0, 0],
                            [0, 0],
                          ],
                          o: [
                            [0, 0],
                            [-10.63, 37.62],
                            [-39.87, 0],
                            [0, 0],
                            [1.01, 0],
                            [0, 0],
                            [0, 0],
                            [0.43, 1.06],
                            [0, 0],
                            [1.15, 0],
                            [0, 0],
                            [0, 0],
                            [0.39, 1.15],
                          ],
                          v: [
                            [28.2, -8.495],
                            [85.76, -8.495],
                            [-0.48, 56.695],
                            [-85.76, -5.335],
                            [-42.62, -5.335],
                            [-40.17, -6.725],
                            [-28.88, -25.905],
                            [-18.17, 0.135],
                            [-15.55, 1.885],
                            [-15.54, 1.885],
                            [-12.92, 0.115],
                            [9.92, -56.695],
                            [25.51, -10.415],
                          ],
                          c: true,
                        },
                        ix: 2,
                      },
                      nm: "Path 1",
                      mn: "ADBE Vector Shape - Group",
                      hd: false,
                    },
                    {
                      ty: "fl",
                      c: {
                        a: 0,
                        k: [0.341176470588, 0.85882358925, 0.917647118662, 1],
                        ix: 4,
                      },
                      o: { a: 0, k: 100, ix: 5 },
                      r: 1,
                      bm: 0,
                      nm: "Fill 1",
                      mn: "ADBE Vector Graphic - Fill",
                      hd: false,
                    },
                    {
                      ty: "tr",
                      p: { a: 0, k: [90.341, 152.979], ix: 2 },
                      a: { a: 0, k: [0, 0], ix: 1 },
                      s: { a: 0, k: [100, 100], ix: 3 },
                      r: { a: 0, k: 0, ix: 6 },
                      o: { a: 0, k: 100, ix: 7 },
                      sk: { a: 0, k: 0, ix: 4 },
                      sa: { a: 0, k: 0, ix: 5 },
                      nm: "Transform",
                    },
                  ],
                  nm: "Group 1",
                  np: 2,
                  cix: 2,
                  bm: 0,
                  ix: 1,
                  mn: "ADBE Vector Group",
                  hd: false,
                },
                {
                  ty: "gr",
                  it: [
                    {
                      ind: 0,
                      ty: "sh",
                      ix: 1,
                      ks: {
                        a: 0,
                        k: {
                          i: [
                            [3.25, 0],
                            [0, 3.24],
                            [-3.24, 0],
                            [0, -3.25],
                          ],
                          o: [
                            [-3.24, 0],
                            [0, -3.25],
                            [3.25, 0],
                            [0, 3.24],
                          ],
                          v: [
                            [42.465, 23.175],
                            [36.595, 17.295],
                            [42.465, 11.415],
                            [48.345, 17.295],
                          ],
                          c: true,
                        },
                        ix: 2,
                      },
                      nm: "Path 1",
                      mn: "ADBE Vector Shape - Group",
                      hd: false,
                    },
                    {
                      ind: 1,
                      ty: "sh",
                      ix: 2,
                      ks: {
                        a: 0,
                        k: {
                          i: [
                            [29.32, 18.22],
                            [2.01, 1.25],
                            [0, 0],
                            [45.07, 0],
                            [2.13, -0.15],
                            [2.63, 1.61],
                            [5.36, -6.97],
                            [-0.73, -0.1],
                            [0, 0],
                            [0, 0],
                            [0, -25.73],
                            [-1.76, -7.01],
                            [0, 0],
                            [0, 0],
                            [-1.07, -0.07],
                            [-0.41, -0.99],
                            [0, 0],
                            [0, 0],
                            [-1.19, -0.05],
                            [-0.37, -1.12],
                            [0, 0],
                            [0, 0],
                            [-8.94, -9.32],
                          ],
                          o: [
                            [-2.39, -1.48],
                            [0, 0],
                            [-6.3, -43.32],
                            [-2.16, 0],
                            [-1.79, -1.44],
                            [-42.18, -25.85],
                            [-0.45, 0.58],
                            [20.02, 2.83],
                            [0, 0],
                            [-17.37, 16.33],
                            [0, 7.56],
                            [0, 0],
                            [0, 0],
                            [0.54, -0.92],
                            [1.07, 0.08],
                            [0, 0],
                            [0, 0],
                            [0.44, -1.1],
                            [1.19, 0.04],
                            [0, 0],
                            [0, 0],
                            [3.48, 0.63],
                            [0, 0],
                          ],
                          v: [
                            [77.775, 35.515],
                            [71.185, 31.415],
                            [71.185, 31.405],
                            [-17.485, -45.195],
                            [-23.925, -44.965],
                            [-30.535, -49.545],
                            [-105.205, -37.525],
                            [-104.585, -35.995],
                            [-79.175, -20.835],
                            [-78.885, -20.835],
                            [-107.095, 44.415],
                            [-104.395, 66.325],
                            [-61.245, 66.325],
                            [-47.875, 43.625],
                            [-45.235, 42.235],
                            [-42.815, 43.985],
                            [-32.585, 68.855],
                            [-9.475, 11.395],
                            [-6.765, 9.615],
                            [-4.165, 11.545],
                            [13.235, 63.175],
                            [70.155, 63.175],
                            [95.285, 75.395],
                          ],
                          c: true,
                        },
                        ix: 2,
                      },
                      nm: "Path 2",
                      mn: "ADBE Vector Shape - Group",
                      hd: false,
                    },
                    {
                      ty: "mm",
                      mm: 1,
                      nm: "Merge Paths 1",
                      mn: "ADBE Vector Filter - Merge",
                      hd: false,
                    },
                    {
                      ty: "fl",
                      c: {
                        a: 0,
                        k: [0.654901960784, 0.317647058824, 1, 1],
                        ix: 4,
                      },
                      o: { a: 0, k: 100, ix: 5 },
                      r: 1,
                      bm: 0,
                      nm: "Fill 1",
                      mn: "ADBE Vector Graphic - Fill",
                      hd: false,
                    },
                    {
                      ty: "tr",
                      p: { a: 0, k: [107.345, 75.645], ix: 2 },
                      a: { a: 0, k: [0, 0], ix: 1 },
                      s: { a: 0, k: [100, 100], ix: 3 },
                      r: { a: 0, k: 0, ix: 6 },
                      o: { a: 0, k: 100, ix: 7 },
                      sk: { a: 0, k: 0, ix: 4 },
                      sa: { a: 0, k: 0, ix: 5 },
                      nm: "Transform",
                    },
                  ],
                  nm: "Group 2",
                  np: 4,
                  cix: 2,
                  bm: 0,
                  ix: 2,
                  mn: "ADBE Vector Group",
                  hd: false,
                },
              ],
              ip: 0,
              op: 722.000029407663,
              st: 0,
              bm: 0,
            },
            {
              ddd: 0,
              ind: 2,
              ty: 4,
              nm: "Shape Layer 1",
              sr: 1,
              ks: {
                o: { a: 0, k: 100, ix: 11 },
                r: { a: 0, k: 0, ix: 10 },
                p: { a: 0, k: [298, 421, 0], ix: 2, l: 2 },
                a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
                s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
              },
              ao: 0,
              shapes: [],
              ip: 0,
              op: 722.000029407663,
              st: 0,
              bm: 0,
            },
          ],
          markers: [],
        },
      }}
    />
  </div>
);

export default LoadingPage;
